import React, { Component } from "react";
import { Modal } from "antd";
import { connect } from "react-redux";
import { closeModal } from "./modalActions";
import MultipleSelectionReason from "../blankSelection/modal/MultipleSelectionReason";

const actions = { closeModal };

class MultipleBlankReasonModal extends Component {
  render() {
    const { closeModal, internalOrderId } = this.props;
    return (
      <Modal
        title="Blank Selection"
        visible={true}
        onCancel={closeModal}
        width="25%"
        footer={null}
      >
        <MultipleSelectionReason internalOrderId={internalOrderId} />
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(MultipleBlankReasonModal);
